"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var pusherAppCluster = 'eu';
/**
 * @param {string} subdomain
 */

var getSocketIoUrl = function getSocketIoUrl(subdomain) {
  var prefix = subdomain ? "".concat(subdomain, ".") : '';
  var url = "https://".concat(prefix, "apinettoken.com/v1/pusher/auth");
  return url;
};

var environment = {
  development: {
    pusherAppCluster: pusherAppCluster,
    pusherAppKey: '3f201394169bb8f67e15',
    socketIoUrl: getSocketIoUrl('dev')
  },
  stage: {
    pusherAppCluster: pusherAppCluster,
    pusherAppKey: '288f67b5bff47b923b35',
    socketIoUrl: getSocketIoUrl('stage')
  },
  production: {
    pusherAppCluster: pusherAppCluster,
    pusherAppKey: 'b2f90b75fefe1978eee0',
    socketIoUrl: getSocketIoUrl()
  }
};
/**
 * @param {string} env
 */

var getEnvironment = function getEnvironment(env) {
  return environment[env];
};

var _default = getEnvironment;
exports.default = _default;